import Tab from './Tab';
import TabsLegacy from './TabsLegacy';

const Tabs = TabsLegacy;

export default Tabs;
export { Tab };
